import { render, staticRenderFns } from "./RoleBadge.vue?vue&type=template&id=bd74fbac&scoped=true"
import script from "./RoleBadge.vue?vue&type=script&lang=js"
export * from "./RoleBadge.vue?vue&type=script&lang=js"
import style0 from "./RoleBadge.vue?vue&type=style&index=0&id=bd74fbac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd74fbac",
  null
  
)

export default component.exports